import { useContext } from 'react';
import { StatTile } from '@/components/ui/stat-tile';
import AuthContext from '../../../../contexts/auth';
import { translate } from "../../../../utils/Common";

// Total retirado (o entregado, si es proveedor) en el mes.
const GraphPackagesPickUpByPlatform = ({ cantPackagesPickUp }) => {
  const userContext = useContext(AuthContext);
  const isProvider = userContext.user?.IdTipoUsuario === 1;

  return (
    <StatTile
      loading={cantPackagesPickUp === null}
      value={(cantPackagesPickUp || []).reduce((n, p) => n + (p.value || 0), 0)}
      label={
        isProvider
          ? translate("dashboard.home.package_delivered")
          : translate("dashboard.home.package_withdrawn")
      }
      info={
        isProvider
          ? translate("dashboard.home.package_withdrawn.help1")
          : translate("dashboard.home.package_withdrawn.help2")
      }
    />
  );
};

export default GraphPackagesPickUpByPlatform;
